<section class="login">
  <div class="container-fluid">
    <div class="row no-padding">
      <div class="col-xs-offset-1 col-xs-10">
        <div class="login-content">
          <div class="logo">
            <img src="/assets/images/logo.png" alt="EDP - Distribuição" />
          </div>
          <div class="user-recovery">
            <h1 class="card-title text-center">Recuperação de Password</h1>
            <form [formGroup]="recoveryForm" autocomplete="off">
              <div class="form-group" *ngIf="f.pwd">
                <label for="pwd" class="font-weight-bold text-left">Insira a password:</label>
                <div class="input-group">
                  <input
                    appPasswordToggle
                    type="password"
                    class="form-control"
                    autocomplete="off"
                    formControlName="pwd"
                    id="pwd"
                    placeholder="Nova password"
                    minlength="10"
                    maxlength="15"
                    (input)="checkPwd($event)"
                  />
                </div>
                <div class="strength">
                  <ul id="strengthBar">
                    <li class="point" *ngFor="let bar of barArray" [style.background-color]="bar"></li>
                  </ul>
                  <p>{{ pwdLabel }}</p>
                </div>
              </div>
              <div class="form-group" *ngIf="f.confirmPwd">
                <label for="confirmPwd" class="font-weight-bold text-left">Confirme a password:</label>
                <div class="input-group">
                  <input
                    appPasswordToggle
                    type="password"
                    class="form-control"
                    autocomplete="off"
                    formControlName="confirmPwd"
                    id="confirmPwd"
                    placeholder="Repetir password"
                    minlength="10"
                    maxlength="15"
                  />
                </div>
              </div>
              <div class="form-group alert alert-danger text-center" *ngIf="invalidPwd">
                A password não respeita as regras, por favor introduza uma nova.
              </div>
              <div
                class="form-group alert alert-danger text-center"
                *ngIf="f.confirmPwd.errors && f.confirmPwd.errors.MatchPassword"
              >
                As passwords inseridas não correspondem.
              </div>
              <div class="form-group text-center">
                <button type="button" class="edp-btn btn-gray pull-left" (click)="openRules()">
                  Regras de validação
                </button>
                <button
                  type="submit"
                  class="edp-btn btn-yellow pull-right"
                  [disabled]="!recoveryForm.valid || invalidPwd"
                  (click)="onRecoveryPassword()"
                >
                  Submeter
                </button>
              </div>
            </form>
          </div>
        </div>
        <div class="col-md-1"></div>
      </div>
    </div>
  </div>
</section>
